import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * SSR-safe wrapper around localStorage / sessionStorage.
 * On the server (prerender / SSR) all reads return null and writes are no-ops,
 * so components can use storage without crashing the build.
 */
@Injectable({ providedIn: 'root' })
export class StorageService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  // ---- localStorage ----
  setLocal(key: string, value: string): void {
    if (this.isBrowser) localStorage.setItem(key, value);
  }

  getLocal(key: string): string | null {
    return this.isBrowser ? localStorage.getItem(key) : null;
  }

  removeLocal(key: string): void {
    if (this.isBrowser) localStorage.removeItem(key);
  }

  // ---- sessionStorage ----
  setSession(key: string, value: string): void {
    if (this.isBrowser) sessionStorage.setItem(key, value);
  }

  getSession(key: string): string | null {
    return this.isBrowser ? sessionStorage.getItem(key) : null;
  }

  clearSession(): void {
    if (this.isBrowser) sessionStorage.clear();
  }

  // ---- both ----
  clearAll(): void {
    if (this.isBrowser) {
      localStorage.clear();
      sessionStorage.clear();
    }
  }
}
